// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

import { useTranslation } from "react-i18next";

/** "Load more" for the cursor lists of §9.1. Renders nothing when the list is complete. */
export function Pager({
  hasNextPage,
  isFetchingNextPage,
  onMore,
}: {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onMore: () => void;
}) {
  const { t } = useTranslation();
  if (!hasNextPage) return null;
  return (
    <button type="button" onClick={onMore} disabled={isFetchingNextPage}>
      {isFetchingNextPage ? t("common.loading") : t("common.more")}
    </button>
  );
}
